/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { useState } from 'react';

import classNames from 'classnames';

import { breakpoints } from '@coursera/cds-core';

import { TrackedCdsButton } from 'bundles/common/components/withSingleTracked';
import EnrollModal from 'bundles/enroll-modal/components/EnrollModal';

import _t from 'i18n!nls/learner-progress';

type PropsFromCaller = {
  className?: string;
  courseId: string;
  buttonText?: string;
  buttonClassName?: string;
  addExtraPadding?: boolean;
};

type PropsToComponent = PropsFromCaller;

const styles = {
  auditFlowUpgrade: () => css`
    margin: var(--cds-spacing-200) 0 var(--cds-spacing-600);
    ${breakpoints.down('md')} {
      margin: var(--cds-spacing-150) 0 var(--cds-spacing-400);
    }
  `,
  cta: () => css`
    padding: 0 var(--cds-spacing-200);
  `,
};

const PurchaseCoursePromptButton = (props: PropsToComponent) => {
  const { className, courseId, buttonText, buttonClassName, addExtraPadding } = props;
  const [showModal, setShowModal] = useState(false);

  const onClick = () => setShowModal(true);

  const onClose = () => setShowModal(false);

  return (
    <div className={classNames('rc-PurchaseCoursePromptButton', className)}>
      <div css={addExtraPadding && styles.cta}>
        <TrackedCdsButton
          className={classNames('c-open-single-page-action-button', buttonClassName || 'primary')}
          onClick={onClick}
          trackingName="upgrade"
        >
          {buttonText || _t('Upgrade to submit')}
        </TrackedCdsButton>
        {showModal && <EnrollModal courseId={courseId} onClose={onClose} />}
      </div>
    </div>
  );
};

export default PurchaseCoursePromptButton;
